// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__335lP","col":"styles_col__35yDK"};